import { RefObject } from 'react'
import useMapHover from '../useMapHover/useMapHover'
import { TooltipDictionary } from '../useMapTooltipContent'
import { CustomOffsets } from '../utils/getRelativeCoordinates'

type UseMapRegionHoverProps = {
  svgRef: RefObject<SVGSVGElement>
  containerRef: RefObject<HTMLDivElement>
  tooltips: TooltipDictionary
  customOffsets?: CustomOffsets
  enabled?: boolean
}

function getFormattedId(id: string) {
  return id.replace('regiao-', '').replace('-', '').toLowerCase()
}

const useMapRegionHover = ({
  svgRef,
  containerRef,
  tooltips,
  customOffsets = {},
  enabled = false
}: UseMapRegionHoverProps) => {
  const { key, tooltipCoordinates } = useMapHover({
    svgRef,
    containerRef,
    tooltips,
    enabled,
    elementSelector: '[id^="regiao-"]',
    labelSelector: 'text',
    idFormatter: getFormattedId,
    getLabelGroupSelector: (formattedId: string) =>
      `[id=regiao-${formattedId}]`,
    customOffsets
  })

  return {
    regionKey: key,
    tooltipCoordinates
  }
}

export default useMapRegionHover
